// extracted by mini-css-extract-plugin
export default {"signincontent":"SignIn_signincontent__P+9pY","signinp":"SignIn_signinp__nXMDT"};